import { type RestaurantStatus } from "./options";

const DEFAULT_RESTAURANT_STATUSES: RestaurantStatus[] = ["LIVE", "ON_HOLD"];

export default DEFAULT_RESTAURANT_STATUSES;

export function areRestaurantStatusesDefault(
  value: RestaurantStatus[],
): boolean {
  const norm = (statuses: RestaurantStatus[]) => [...statuses].sort().join(",");
  return norm(value) === norm(DEFAULT_RESTAURANT_STATUSES);
}
